import { useTranslations } from '@vocab/react';
import { Alert, Stack, Text, TextLink, List, Box } from 'braid-design-system';
import type React from 'react';

import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';

import translations from './.vocab';

interface Props {
  renderAlert?: boolean;
  errorLocations?: Array<string | undefined>;
}

export const ErrorAlertOnSuccess = ({ errorLocations }: Props) => {
  const { t } = useTranslations(translations);
  const { createContactUsUrl } = useLocalisedRoutes();

  return (
    <Alert tone="critical">
      <Stack space="small">
        <Text>{t('error-alert-error-message')}</Text>
        {errorLocations &&
          errorLocations.map((location) => (
            <List key={location}>
              <Text>
                {location && t('error-alert-job-location', { location })}
              </Text>
            </List>
          ))}
        <Box marginTop="medium" />
        <Text>
          {t('error-alert-some-jobs-failed', {
            Link: (children: React.ReactNode[]) => (
              <TextLink href={createContactUsUrl()}>{children}</TextLink>
            ),
          })}
        </Text>
      </Stack>
    </Alert>
  );
};

export const ErrorAlert = ({ renderAlert = true }: Props) => {
  const { t } = useTranslations(translations);
  const { createContactUsUrl } = useLocalisedRoutes();

  return renderAlert ? (
    <Alert tone="critical">
      <Stack space="small">
        <Text>
          {t('error-alert-all-failed', {
            Link: (children: React.ReactNode[]) => (
              <TextLink href={createContactUsUrl()}>{children}</TextLink>
            ),
          })}
        </Text>
      </Stack>
    </Alert>
  ) : null;
};
